import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BankAccountDocumentScannerRequestRegistrationForm } from './models';

export type RegisterBankAccountDocumentScannerRequestMutationTrigger =
  ReturnType<typeof useRegisterBankAccountDocumentScannerRequestMutation>[0];

export const bankAccountDocumentScannerApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'hl-ai-bank-account-doc-scanner-api',
  endpoints: (build) => ({
    registerBankAccountDocumentScannerRequest: build.mutation<
      void,
      BankAccountDocumentScannerRequestRegistrationForm
    >({
      query: (data) => ({
        url: `/secured/bank-account-document-scanner/register-request`,
        method: 'POST',
        data
      })
    })
  })
});

export const { useRegisterBankAccountDocumentScannerRequestMutation } =
  bankAccountDocumentScannerApi;
